<style src="./Loader.scss" lang="scss"></style>

<template lang="pug">
  .loader(
    :class='`is-${type}`'
  )
    svg.loader__spinner(
      viewBox="0 0 50 50"
    )
      circle(
        cx="25"
        cy="25"
        r="20"
        fill="none"
        stroke-width="5"
      )
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "page"
    }
  }
};
</script>
